var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileAvatarMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 92,
    viewBox: "0 0 96 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8348 0.397768C30.3079 1.84132 24.5342 5.51805 21.2425 11.7435C15.3448 22.8975 17.8536 31.0611 15.7912 39.303C13.7287 47.545 7.40539 50.3078 2.85745 56.7587C-0.692413 61.794 -1.25316 74.0416 5.10845 80.157C11.4022 86.1591 17.2059 91.7244 28.5057 90.0287C39.6923 88.4008 45.3324 80.8616 57.0852 78.5093C68.838 76.1569 78.572 78.3108 84.8265 72.7287C91.3849 66.8753 98.2072 50.6857 92.3471 39.0005C87.6335 29.6017 76.1731 27.4974 70.582 18.6875C64.9909 9.87773 62.3084 5.95487 57.4859 3.84831C50.8192 0.936135 45.8027 -0.781837 38.8348 0.397768Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatarMask);
export default __webpack_public_path__ + "static/media/profile-avatar-mask.d03392a0aa27c2c14934b7ccfdd04f01.svg";
export { ForwardRef as ReactComponent };